module.exports = __webpack_public_path__ + "static/whatsapp-3ac28136e77209feed1df0856d0d6970.svg";